import React from 'react';
import { useSelector } from 'react-redux';

import Seo from 'components/Seo';

import LoginRedirect from './LoginRedirect';
import AccountWrapper from './AccountWrapper';

const Account = () => {
    const isLoggedIn = useSelector(state => state.user.auth.loggedIn);

    if (!isLoggedIn) {
        return <LoginRedirect />;
    }

    return (
        <>
            <Seo title="Your Account" noindex />
            <AccountWrapper />
        </>
    );
};

export default Account;
